import { createFileRoute, Navigate } from "@tanstack/react-router";
import { GithubKit } from "@/components/github/kit";
import { SlackKit } from "@/components/slack/kit";

export const Route = createFileRoute("/kit")({
  component: KitPage,
});

/**
 * The component kit: screens drawn from fixtures, in the states that are
 * hard to reach by hand. For looking at, in both themes and at every width.
 * Each area adds its own section here.
 *
 * Only in development: the fixtures are not part of the product, and the
 * production build leaves them out.
 */
function KitPage() {
  if (!import.meta.env.DEV) return <Navigate to="/" replace />;
  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-5xl flex-col gap-12 px-4 py-8 md:px-8">
      <h1 className="type-title">Kit</h1>
      <KitSection title="GitHub">
        <GithubKit />
      </KitSection>
      <KitSection title="Slack">
        <SlackKit />
      </KitSection>
    </main>
  );
}

function KitSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-6 border-t pt-6">
      <h2 className="type-section">{title}</h2>
      {children}
    </div>
  );
}
